import { TMedia } from '@renderer-ui-library/molecules'

export const isLocalMedia = (media: TMedia) =>
  media.attributes.url.indexOf('/') === 0
